/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
import { GenealogySource, Parent } from "../Genealogy/types";

let sources: GenealogySource[];

const getSource = (id: string): GenealogySource[] => {
  return sources.filter((s) => s.id === id);
};

const getSources = (ids: string[]): GenealogySource[] => {
  return sources.filter((source) => ids.filter((id) => source.id === id).length > 0);
};

/**
Status zoektocht naar Gijsbertus/Gisbertus Beckers:
https://www.wiewaswie.nl - Zou deze kunnen zijn: https://www.bhic.nl/memorix/genealogy/search/deeds/c0933dd2-a702-0c72-ad5d-4d5feb1e1dbf. Dit is de doop in een RK kerk, dus dat is een match. Diessen is echter wel wat ver weg van Druten.
https://www.genealogieonline.nl - geen info
https://www.familysearch.org - hier wordt beweerd gedoopt op 12-02-1762, maar de naam 'Bekkers' komt daarin helemaal niet voor dus dat klopt gewoonweg niet! Dit is 
dezelfde match: https://permalink.geldersarchief.nl/7872300D025D4471B87300F2292272A9
 */

export const getBekkersParents = (genSources: GenealogySource[]): Parent[] => {
  sources = genSources;

  const parents = [];

  parents.push({
    name: "Gijsbertus/Gisbertus/Gijp Bekkers",
    backgroundInfo: {
      text: "meer info op https://gw.geneanet.org/vandrempt?lang=nl&n=bekkers&p=gijsbertus. De geboortes die in Puijflijk hebben plaatsgevonden zijn wel terug te vinden in het Gelders Archief, maar er zijn geen digitale scans beschikbaar van de aktes zelf. Gijsbertus wordt afwisselend gespeld als Gijsbertus, Gijp of Gisbertus, en Thecla afwisselend als Thecla en Tijske",
    },
    death: {
      sources: getSource("1829GAHA"),
      date: "09-04-1806",
      city: "Druten",
    },
    mariages: [
      {
        sources: getSource("1787DPHA"),
        date: "07-05-1787",
        city: "Puijflijk",
        partner: {
          name: "Tijske/Thecla Bouwens",
          birth: {
            date: "rond 1752",
          },
          death: {
            date: "12-10-1826",
            city: "Druten",
          },
        },
        children: [
          {
            name: "Antonetta Bekkers",
            baptism: {
              date: "25-02-1788",
              city: "Puijflijk",
            },
          },
          {
            name: "Francisca Bekkers",
            baptism: {
              date: "13-11-1789",
              city: "Puijflijk",
            },
          },
          {
            name: "Gertrudis Bekkers",
            baptism: {
              date: "02-09-1791",
              city: "Puijflijk",
            },
          },
          {
            name: "Jacobus Beckers",
            birth: {
              sources: getSource("1831GAHA"),
              date: "22-02-1793",
              city: "Afferden (Druten)",
            },
            baptism: {
              date: "22-02-1793",
              city: "Puijflijk",
            },
            death: {
              sources: getSource("1867GAOA"),
              date: "22-11-1867",
              city: "Afferden (Druten)",
            },
          },
          {
            name: "Maria Bekkers",
            baptism: {
              sources: getSource("1795DPGA"),
              date: "23-02-1795",
              city: "Puijflijk",
            },
          },
          {
            name: "Gerrarda Bekkers",
            baptism: {
              sources: getSource("1799GAGA"),
              date: "31-03-1799",
              city: "Druten",
            },
          },
          {
            name: "Nicolaas Bekkers",
            baptism: {
              sources: getSources(["1800RNGK", "1839RNHA"]),
              date: "17-06-1800",
              city: "Druten",
            },
            death: {
              sources: getSource("1869RNOA"),
              date: "14-03-1869",
              city: "Venray",
            },
          },
        ],
      },
    ],
  });

  // Generation
  parents.push({
    name: "Jacobus Beckers",
    backgroundInfo: {
      text: "Jacob was arbeider van beroep. In alle aktes waar zijn handtekening gevraagd werd verklaarde hij 'niet te kunnen schrijven'. In die tijd was niet kunnen schrijven overigens redelijk normaal. Het verklaard wellicht wel waarom zijn naam zeer wisselend werd geschreven; Jacobus/Jacob/Jakob en Beckers/Bekkers. De enige logische conclusie uit de geboortedata van 'Adriana' en 'Adrianus' Bekkers is dat zij een tweeling waren. Het vreemde is echter dat van Adriana een geboorteakte te vinden is, maar van Adrianus niet. Wellicht is deze gewoonweg kwijtgeraakt?",
    },
    birth: {
      sources: getSource("1831GAHA"),
      date: "22-02-1793",
      city: "Afferden (Druten)",
    },
    death: {
      sources: getSource("1867GAOA"),
      date: "22-11-1867",
      city: "Afferden (Druten)",
    },
    mariages: [
      {
        sources: getSource("1827GAHA"),
        date: "23-05-1827",
        city: "Appeltern",
        partner: {
          name: "Johanna Belgers",
          baptism: {
            date: "05-04-1795",
            city: "Maasbommel",
            sources: getSources(["1827GAHA", "1795DADR"]),
          },
          death: {
            sources: getSource("1830GAOA"),
            date: "01-07-1830",
            city: "Druten",
          },
        },
        children: [
          {
            name: "Gijsbertus Wilhelmus Bekkers",
            birth: {
              sources: getSource("1828GAGA"),
              date: "05-04-1828",
              city: "Druten",
            },
            death: {
              sources: getSource("1852GAOA"),
              date: "06-07-1852",
              city: "Ijzendoorn",
            },
          },
        ],
      },
      {
        sources: getSource("1831GAHA"),
        date: "13-01-1831",
        city: "Druten",
        partner: {
          name: "Catharina Vermeer",
          birth: {
            sources: getSource("1831GAHA"),
            date: "07-11-1796",
            city: "Afferden (Druten)",
          },
          death: {
            date: "26-03-1847",
            city: "Druten",
            sources: getSource("1859GAHA"),
          },
          backgroundInfo: {
            text: "Catharina was winkelierster van beroep.",
          },
        },
        children: [
          {
            name: "Johannes Bekkers",
            mainAncestor: true,
            birth: {
              sources: getSource("1859GAHA"),
              date: "10-05-1832",
              city: "Druten",
            },
          },
          {
            name: "Adrianus Bekkers",
            birth: {
              sources: getSource("1835GAGA"),
              date: "08-03-1835",
              city: "Druten",
            },
            death: {
              sources: getSource("1836GAOA"),
              date: "07-01-1836",
              city: "Druten",
            },
          },
          {
            name: "Adriana Bekkers",
            birth: {
              sources: getSource("1837GAGA"),
              date: "03-08-1837",
              city: "Druten",
            },
          },
          {
            name: "Adrianus Bekkers",
            birth: {
              sources: getSource("1838GAOA"),
              date: "Rond juli 1837",
              city: "Druten",
            },
            death: {
              sources: getSource("1838GAOA"),
              date: "18-04-1838",
              city: "Druten",
            },
          },
        ],
      },
    ],
  });

  // Generation
  parents.push({
    name: "Johannes Bekkers",
    backgroundInfo: {
      text: "Johannes was arbeider van beroep, en later schipper. Bij zijn overlijden was hij 'tabaksplanter'",
    },
    birth: {
      sources: getSources(["1859GAHA", "1832GAGA"]),
      date: "10-05-1832",
      city: "Druten",
    },
    death: {
      sources: getSource("1893GAOA"),
      date: "30-09-1893",
      city: "Druten",
    },
    mariages: [
      {
        date: "21-01-1859",
        city: "Druten",
        sources: getSource("1859GAHA"),
        partner: {
          name: "Margaretha van den Heuvel",
          birth: {
            date: "13-11-1836",
            city: "Afferden (bij Druten)",
          },
        },
        children: [
          {
            name: "Gijsbertus Bekkers",
            birth: {
              sources: getSource("1859GAGA"),
              date: "04-04-1859",
              city: "Druten",
            },
          },
          {
            name: "Willem Bekkers",
            birth: {
              sources: getSource("1861GAGA"),
              date: "20-11-1861",
              city: "Druten",
            },
          },
          {
            name: "Jacobus Bekkers",
            birth: {
              sources: getSource("1864GAGA"),
              date: "09-11-1864",
              city: "Druten",
            },
          },
          {
            name: "Catharina Bekkers",
            birth: {
              sources: getSource("1866GAGA"),
              date: "08-11-1866",
              city: "Druten",
            },
          },
          {
            name: "Cornelia Bekkers",
            birth: {
              sources: getSource("1870GAGA"),
              date: "15-03-1870",
              city: "Druten",
            },
          },
          {
            name: "Hubertus Bekkers",
            mainAncestor: true,
            birth: {
              sources: getSource("1874GAGA"),
              date: "29-12-1874",
              city: "Druten",
            },
          },
          {
            name: "Margaretha Maria Berdina Bekkers",
            birth: {
              sources: getSource("1881GAGA"),
              date: "15-08-1881",
              city: "Druten",
            },
          },
        ],
      },
    ],
  });

  // Generation
  parents.push({
    name: "Hubertus Bekkers",
    backgroundInfo: {
      text: "Hubertus was 'varensgezel' van beroep, later ook 'stuurman', 'sleepbootkapitein' en 'wachtsman'.",
    },
    birth: {
      date: "29-12-1874",
      city: "Druten",
      sources: getSource("1874GAGA"),
    },
    mariages: [
      {
        date: "27-12-1901",
        city: "Rotterdam",
        sources: getSource("1901SRHA"),
        partner: {
          name: "Christina Hörnemann",
          birth: {
            date: "1879",
            city: "Rotterdam",
          },
          death: {
            sources: getSource("1933SROA"),
            date: "30-11-1933",
            city: "Rotterdam",
          },
        },
        children: [
          {
            name: "Margaretha Elizabeth Christina Bekkers",
            birth: {
              sources: getSource("1903SRGA"),
              date: "03-06-1903",
              city: "Rotterdam",
            },
          },
          {
            name: "Elizabeth Johanna Bekkers",
            birth: {
              sources: getSource("1907SRGA"),
              date: "29-09-1907",
              city: "Rotterdam",
            },
          },
          {
            mainAncestor: true,
            name: "Hubertus Christiaan Maria Bekkers",
            birth: {
              sources: getSources(["1910SRGA", "1940SRGK"]),
              date: "31-08-1910",
              city: "Rotterdam",
            },
          },
          {
            name: "Tilmann Johann Bekkers",
            birth: {
              sources: getSource("1916SRGA"),
              date: "12-07-1916",
              city: "Rotterdam",
            },
          },
        ],
      },
    ],
  });

  // Generation
  parents.push({
    name: "Hubertus Christiaan Maria Bekkers",
    backgroundInfo: {
      text: "Hubertus was matroos van beroep. In de huwelijksakte staat 'Bij beschikking van den Officier van Justitie bij de Arrondissements rechtbank alhier van heden is dispensatie verleend van de afkondiging van dit huwelijk en van den bij artikel honderddertig van het Burgerlijk Wetboek voorgeschreven wachttijd'. Een verklaring voor die extra zin zou kunnen zijn dat Katharina hoogzwanger was tijdens dit huwelijk. Op de gezinskaart van 1940 staat achter de naam van Hubertus 'GD', wat vermoedelijk 'gewoon dienstplichtig' betekent.",
    },
    birth: {
      sources: getSources(["1910SRGA", "1940SRGK"]),
      date: "31-08-1910",
      city: "Rotterdam",
    },
    mariages: [
      {
        date: "18-03-1937",
        city: "Rotterdam",
        sources: getSource("1937SRHA"),
        partner: {
          name: "Katharina Teutsch",
          birth: {
            sources: getSource("1940SRGK"),
            date: "22-9-1916",
            city: "Mainz-Weisenau (Duitsland)",
          },
        },
        children: [
          {
            mainAncestor: true,
            name: "Christina Bekkers",
            birth: {
              sources: getSource("1940SRGK"),
              date: "22-05-1937",
              city: "Rotterdam",
            },
            death: {
              date: "12-04-2025",
              city: "Nieuw-Bergen",
            },
          },
        ],
      },
    ],
  });

  return parents;
};
